import { yup } from '@framework/validation';
import { fromPairs } from 'lodash';
import { FormBuilderMetaFlags } from '../../../../../validator/form-builder/flags/FormBuilderMetaFlags';
import { ICreateWidgetFormSchemaInput } from '../../../IWidgetType';
import { getDatatypeOutputSchema } from '../../common/async-widgets/getDatatypeOutputSchema';
import { IAsyncSelectWidget } from './IAsyncSelectWidget';
import { asyncSelectWidgetObjectName } from './hooks/asyncSelectObjectName';

export function createAsyncSelectFormSchema(
  input: ICreateWidgetFormSchemaInput<IAsyncSelectWidget>,
) {
  const { widget } = input;

  const outputs = widget.outputs ?? [];

  const objectSchema = yup
    .object(
      fromPairs(
        outputs.map(output => [
          output.name,
          getDatatypeOutputSchema(output.type),
        ]),
      ),
    )
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipDefaultValue,
      FormBuilderMetaFlags.SkipValidationRules,
    );

  return {
    [widget.code]: yup.string().notRequired(),
    [asyncSelectWidgetObjectName(widget.code)]: objectSchema.notRequired(),
  };
}
